import AsyncStorage from "@react-native-async-storage/async-storage";
import { useRoute } from "@react-navigation/core";
import {
	Button,
	Divider,
	HStack,
	Icon,
	Text,
	useMediaQuery,
	VStack,
} from "native-base";
import React, { useEffect, useState } from "react";
import { Image, Pressable, ScrollView, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";

import ErrorToast from "../../components/ErrorToast";
import LoadingIndicator from "../../components/LoadingIndicator";
import MemberContentArea from "../../components/MemberContentArea";
import { removeAuth } from "../../redux/slices/LoginSlice";
import { getMissingMemberData } from "../../redux/slices/MissingDataSlice";
import { getPage } from "../../redux/slices/PageSlice";
import Constants from "../../utils/Constants";
import {
	getBrandLeftMenuBackgroundColor,
	getBrandLeftMenuTextColor,
	getMenuImg,
	isWeb,
} from "../../utils/utils";
import CardActivation from "./CardActivation";
import DeleteAccount from "./DeleteAccount";
import DisputeClaim from "./DisputeClaim";
import MainMenu from "./MainMenu";
import MissingData from "./MissingData";
import MyHistory from "./MyHistory";
import Profile from "./Profile";
import SubmitClaim from "./SubmitClaim";
import Transaction from "./Transactions";

const BRAND_URL = isWeb() ? Constants.WindowHostname : Constants.CIP_BRAND;

const Member = (props) => {
	const [generalInfo, setGeneralInfo] = useState([]);
	const [AddressInfo, setAddressInfo] = useState([]);
	const [PrimaryIdInfo, setPrimaryIdInfo] = useState([]);
	const [SecondaryIdInfo, setSecondaryIdInfo] = useState([]);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const route = useRoute();
	const dispatch = useDispatch();
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });

	const NavLinks = useSelector((state) => state.Nav.NavLinks);
	const isPageLoading = useSelector((state) => state.Nav.loading);
	const MissingMemberData = useSelector(
		(state) => state.MissingData.MissingData
	);
	const isLoading = useSelector((state) => state.MissingData.loading);

	const isXiaomi = BRAND_URL === Constants.XiaomiURL;

	useEffect(() => {
		try {
			dispatch(getMissingMemberData());
			dispatch(getPage(route.params.slug));
		} catch (error) {
			ErrorToast(error.message);
		}
	}, [route]);

	useEffect(() => {
		if (MissingMemberData.component_children) {
			// let missingData = MissingMemberData.component_children.map((children) =>
			// 	children.component_data_types.filter(
			// 		(subElements) => subElements.data_text === ""
			// 	)
			// );

			let missingAddressInfo = MissingMemberData.component_children
				.filter(
					(children) => children.component_name === "residential_address"
				)[0]
				.component_data_types.filter(
					(subElements) => subElements.data_text === ""
				);

			let missingPrimaryIdInfo = MissingMemberData.component_children
				.filter((children) => children.component_name === "primary_identity")[0]
				.component_data_types.filter(
					(subElements) => subElements.data_text === ""
				);

			let missingSecondaryIdInfo = MissingMemberData.component_children
				.filter(
					(children) => children.component_name === "secondary_identity"
				)[0]
				.component_data_types.filter(
					(subElements) => subElements.data_text === ""
				);

			let missingGeneralInfo = MissingMemberData.component_data_types.filter(
				(subElements) => subElements.data_text === ""
			);

			setGeneralInfo(missingGeneralInfo);
			setAddressInfo(missingAddressInfo);
			setPrimaryIdInfo(missingPrimaryIdInfo);
			setSecondaryIdInfo(missingSecondaryIdInfo);
		}
	}, [MissingMemberData.component_children]);

	return (
		<>
			{isPageLoading && isLoading ? (
				<LoadingIndicator />
			) : (
				<View style={{ flex: 1, flexDirection: "row" }}>
					{isDesktopOrLaptop[0] && (
						<View
							style={{
								backgroundColor: getBrandLeftMenuBackgroundColor(),
								flex: 1,
								paddingHorizontal: 10,
								paddingTop: 50,
							}}
						>
							<View
								style={{
									alignItems: "flex-start",
									justifyContent: "flex-start",
									flex: 1,
								}}
							>
								<VStack space="4">
									<VStack space="3">
										{NavLinks?.data.map((item, NavIndex) => {
											let meta = item.meta_data;
											if (meta.location == "main") {
												if (meta.visible === false) return;

												if (
													item.page_title === "Profile" ||
													item.page_title === "Dispute Claim"
												) {
													return;
												}
												return (
													<Pressable
														key={item.sitepagecomponent_guid}
														px="4"
														py="2"
														rounded="md"
														bg={
															item.page_title === props.route.name
																? "primary.600"
																: "transparent"
														}
														onPress={() => {
															setSelectedIndex(item.page_title);
															props.navigation.navigate(item.page_title);
														}}
													>
														<HStack
															space="4"
															alignItems="center"
															padding={2}
															borderRadius={5}
															bg={
																item.page_title === props.route.name
																	? "primary.100"
																	: "transparent"
															}
														>
															<Icon
																color={
																	item.page_title === props.route.name
																		? "primary.500"
																		: getBrandLeftMenuTextColor()
																}
																size="4"
																as={
																	<Image
																		resizeMode="contain"
																		source={{
																			uri: isWeb()
																				? getMenuImg(item.page_title)
																				: Image.resolveAssetSource(
																						getMenuImg(item.page_title)
																				  ).uri,
																		}}
																		style={{
																			width: 20,
																			height: 20,
																			resizeMode: "contain",
																		}}
																	/>
																}
															/>

															<Text
																fontWeight="600"
																fontSize={12}
																color={
																	item.page_title === props.route.name
																		? "primary.500"
																		: getBrandLeftMenuTextColor()
																}
															>
																{item.page_title}
															</Text>
														</HStack>
													</Pressable>
												);
											}
										})}
									</VStack>
								</VStack>
							</View>
						</View>
					)}

					<View style={{ flex: 7 }}>
						<ScrollView style={{ flex: 1 }}>
							<MemberContentArea>
								<>
									{generalInfo.length > 0 ||
									AddressInfo.length > 0 ||
									PrimaryIdInfo.length > 0 ||
									SecondaryIdInfo.length > 0 ? (
										<ScrollView style={{ flex: 1 }}>
											<MissingData
												{...props}
												generalInfo={generalInfo}
												AddressInfo={AddressInfo}
												PrimaryIdInfo={PrimaryIdInfo}
												SecondaryIdInfo={SecondaryIdInfo}
											/>
										</ScrollView>
									) : (
										<>
											{(() => {
												switch (props.route.name) {
													case "Main Menu":
														return (
															<ScrollView style={{ flex: 1 }}>
																<MainMenu {...props} />
															</ScrollView>
														);
													case "My History":
														return <MyHistory {...props} />;
													case "Submit Claim":
														return (
															<ScrollView style={{ flex: 1 }}>
																<SubmitClaim {...props} />
															</ScrollView>
														);
													case "My Transactions":
														return <Transaction {...props} />;
													case "Dispute Claim":
														return (
															<ScrollView style={{ flex: 1 }}>
																<DisputeClaim {...props} />
															</ScrollView>
														);
													case "Profile":
														return (
															<ScrollView style={{ flex: 1 }}>
																<Profile {...props} />
															</ScrollView>
														);
													case "Manage Card":
														return (
															<ScrollView style={{ flex: 1 }}>
																<CardActivation {...props} />
															</ScrollView>
														);
													case "Delete Profile":
														return (
															<ScrollView style={{ flex: 1 }}>
																<DeleteAccount {...props} />
															</ScrollView>
														);
													default:
														return (
															<ScrollView style={{ flex: 1 }}>
																<MainMenu {...props} />
															</ScrollView>
														);
												}
											})()}
										</>
									)}
								</>
							</MemberContentArea>
						</ScrollView>
					</View>
				</View>
			)}
		</>
	);
};

export default Member;
